import {useContext} from "react";
import {StateContext} from "../Contexts";
import {STEP_ADDRESS, STEP_PAYMENT_PROVIDER_CHANGE, STEP_PLAN} from "../Constants";
import ButtonPrimaryTransparent from "@erecht24/frontend-kit/theme/components/buttons/ButtonPrimaryTransparent";
import FinishOrderButton from "./FinishOrderButton";
import {track} from "../Util/tracking";

export default function () {
    /** @type CheckoutState */
    const state = useContext(StateContext);

    const validatePaymentProviderChange = function () {
        if (state.allowCancellationValidation.length < 1)
            // everything is ok, go to next step
            state.setStep(STEP_ADDRESS);
    }

    if (state.step === STEP_PLAN) {
        return <ButtonPrimaryTransparent onClick={() => track(
            () => state.paymentProviderChangeModeEnabled
                ? state.setStep(STEP_PAYMENT_PROVIDER_CHANGE)
                : state.setStep(STEP_ADDRESS),
            'checkout',
            'navigation',
            'checkout_step',
            'next'
        )} fullWidth={true} className="lg:mt-10">Weiter</ButtonPrimaryTransparent>
    } else if (state.step === STEP_PAYMENT_PROVIDER_CHANGE) {
        return <ButtonPrimaryTransparent onClick={() => track(
            validatePaymentProviderChange,
            'checkout',
            'navigation',
            'checkout_step',
            'next'
            )}
            fullWidth={true}
            className="lg:mt-10"
            disabled={!state.allowCancellation || state.allowCancellationValidation.length > 0}
        >Weiter</ButtonPrimaryTransparent>
    }

    return <FinishOrderButton upgrade={state.cartViewData.cartType !== 'initial_purchase'}></FinishOrderButton>
}
